import {default as _debounce} from 'lodash.debounce'
import GmapsLoader from './gmapsLoader.js';
import ScrollToError from './scrollToError.js';
import FallbackImage from './fallbackImage.js';

const debounce = (cb) => _debounce(cb ,300, {leading: true, trailing: false});

export { GmapsLoader, ScrollToError, FallbackImage,  debounce};
